import { createSlice } from '@reduxjs/toolkit';
import { FiltersInitialValue, SearchStatus } from '../../constants';

const initialState = {
  customInventorySearches: {},
};

const customInventorySlice = createSlice({
  name: 'customInventory',
  initialState,
  reducers: {
    customInventorySearchTripId: (state, { payload: { tripId } }) => ({
      ...state,
      customInventorySearches: {
        ...state.customInventorySearches,
        [tripId]: {
          ...(state.customInventorySearches[tripId] || {}),
          searchStatus: SearchStatus.SEARCHING,
        },
      },
    }),
    customInventorySearchSuccess: (state, { payload: { response, tripId, queryString } }) => ({
      ...state,
      customInventorySearches: {
        ...state.customInventorySearches,
        [tripId]: {
          ...state.customInventorySearches[tripId],
          searchStatus: SearchStatus.DONE,
          response: { ...response },
          [queryString]: queryString,
        },
      },
    }),
    updateCustomInventorySearchObj: (
      state,
      { payload: { tripId, defaultSearchObj, searchObj, searchStatus } },
    ) => ({
      ...state,
      customInventorySearches: {
        ...state.customInventorySearches,
        [tripId]: {
          ...state.customInventorySearches[tripId],
          defaultSearchObj: {
            ...FiltersInitialValue.customInventory,
            ...(state.customInventorySearches[tripId] || {}).defaultSearchObj,
            ...defaultSearchObj,
          },
          searchObj: {
            ...FiltersInitialValue.customInventory,
            ...(state.customInventorySearches[tripId] || {}).searchObj,
            ...searchObj,
          },
          searchStatus:
            searchStatus === undefined || searchStatus === null
              ? (state.customInventorySearches[tripId] || {}).searchStatus || SearchStatus.INITIAL
              : searchStatus || SearchStatus.INITIAL,
        },
      },
    }),
  },
});

export const {
  customInventorySearchSuccess,
  updateCustomInventorySearchObj,
  customInventorySearchTripId,
} = customInventorySlice.actions;
export default customInventorySlice.reducer;
